module.exports = __webpack_public_path__ + "static/gap2-8ecd063a0a4b4c320bbeb913eca08554.jpg";